module.exports = __webpack_public_path__ + "static/media/logo_branca_horizontal.90a08c51.png";